import React from 'react';
import { Button } from '../ui/Button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SectionWrapper from './SectionWrapper';

export const CtaSection: React.FC = () => {
  return (
    <SectionWrapper>
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-display font-bold mb-4 text-gray-950">
          Make Journaling Fast, Fun and <span className="gradient-text">Rewarding</span> !
        </h2>
        <p className="text-xl text-gray-700 max-w-2xl mx-auto mb-12">
          The Name of the Game? Stack those "Plan Followed" Days in your calendar ! The rest will take care of itself !
        </p>

        <div className="flex justify-center">
          <Button 
            as={Link} 
            to="/trial" 
            size="lg" 
            className="!rounded-full px-12 py-6 text-xl font-semibold min-w-[240px] shadow-lg hover:shadow-xl flex items-center justify-center bg-black hover:bg-gray-900 text-white transition-all duration-300 animate-float shadow-glow"
          >
            Free Trial
            <ArrowRight size={24} className="ml-3" />
          </Button>
        </div>
      </div>
    </SectionWrapper>
  );
};